import React from 'react'
import "./setupDetails.scss"

import OnboardingItemIntro from '../SetupDetailsUtilities/OnboardingItemIntro'

export interface ISetupChecklist {
    selected: number
    groupData: any
}

const SetupDetails: React.FC<ISetupChecklist> = ({ selected, groupData }) => {

    return (
        <div className='setup-details-wrapper'>
            <div className='setup-details-wrapper-ul'>
                <OnboardingItemIntro
                    title={''}
                    description={''}
                    groupData={groupData}
                    itemsLength={0}
                    compSelected={''}
                />
            </div>
        </div>
    )
}

export default SetupDetails
